module.exports = __webpack_public_path__ + "src/assets/img/toplay.08218e42.png";